import React from "react";
import { Outlet, Link } from 'react-router-dom'
import loginImg from "../assets/login/login_img.png";
import logo from "../assets/login/login_logo.svg";
import bgCircles from '../assets/login/Intersect.svg'; 

const LoginLayout = () => {
    return (      
        <div className="flex h-screen">
            {/* background image for only small screens */}
            <div className="absolute inset-0 lg:hidden">
                <div className="absolute inset-0 bg-[#5AA9A5]">
                    <img src={bgCircles} alt="Decorative Circles" className="absolute top-[-10%] left-[-10%]  h-auto object-contain z-0"/>
                    <img src={loginImg} alt="Elderly Care" className="absolute bottom-0 h-[70%] object-cover z-1"/>
                </div>

            </div>

            <div className="relative z-1 w-full lg:w-3/5 flex justify-center items-center overflow-hidden mx-4 pt-[80px]">
                <div>
                    <Link to="/">
                        <img
                            src={logo}
                            alt="Logo"
                            className="absolute top-[29px] left-[50px] w-[141.81px] h-auto cursor-pointer"
                        />
                    </Link>
                </div>
                <Outlet />
            </div>
            
            <div className="hidden lg:flex relative w-2/5 h-full bg-[#2A8C8A] items-center justify-center rounded-l-[10px] overflow-hidden">
                <div className="relative bg-[#5AA9A5] w-[85%] h-[85%] rounded-[16px] overflow-hidden">
                    
                    {/* Decorative Circles - optional */}
                    <img
                    src={bgCircles}
                    alt="Decorative background"
                    className="absolute top-0 left-[-10%] max-w-[80%] max-h-[60%] object-contain z-3"
                    />

                    {/* Foreground People Image */}
                    <img
                    src={loginImg}
                    alt="Elderly care"
                    className="absolute bottom-0 xl:left-[10%] lg:h-[80%] xl:h-[80%] object-cover z-10"
                    />
                </div>
            </div>

        </div>
    );
}


export default LoginLayout;
